"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenderLabelMapperInternal = exports.GenderLabelMapper = void 0;
var _models = require("../models");
var _Localization = require("./Localization");
var _jsxRuntime = require("react/jsx-runtime");
class GenderLabelMapperInternal {
  getLocalizationKey(label) {
    const transforms = {
      Man: _models.TranslationKey.genderLabelMan,
      Other: _models.TranslationKey.genderLabelOther,
      Woman: _models.TranslationKey.genderLabelWoman,
      _default: label
    };
    const key = label in transforms ? transforms[label] : transforms._default;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: key
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- because we need use as is
      ,

      id: key ?? ''
    });
  }
}
exports.GenderLabelMapperInternal = GenderLabelMapperInternal;
const GenderLabelMapper = exports.GenderLabelMapper = new GenderLabelMapperInternal();